import React from 'react';
export function Problems() {
  const problems = [{
    emoji: '📱',
    text: 'Recurrís a las pantallas porque no sabés qué más hacer'
  }, {
    emoji: '⏰',
    text: 'No tenés tiempo para preparar actividades complicadas'
  }, {
    emoji: '😞',
    text: 'Sentís culpa por no estimular lo suficiente a tu hijo'
  }, {
    emoji: '🧸',
    text: 'Gastás en juguetes que duran dos días y aburren'
  }];
  return <section className="bg-white px-5 py-10 sm:py-12" data-id="element-145">
      <div className="max-w-2xl mx-auto" data-id="element-146">
        <div className="text-center mb-6" data-id="element-147">
          <p className="text-xs uppercase tracking-wider text-brand-green-600 font-bold mb-3" data-id="element-148">
            ¿Te suena?
          </p>
          <h2 className="font-extrabold text-3xl sm:text-4xl text-brand-ink leading-tight tracking-tight" data-id="element-149">
            Las tardes en casa{' '}
            <span className="highlight-yellow" data-id="element-150">no tienen que ser un caos</span>
          </h2>
        </div>

        <ul className="space-y-3" data-id="element-151">
          {problems.map(p => <li key={p.text} className="flex items-start gap-4 bg-slate-50/80 rounded-2xl px-5 py-4 border border-slate-100" data-id="element-152">
              <span className="text-2xl shrink-0" aria-hidden="true" data-id="element-153">
                {p.emoji}
              </span>
              <span className="text-slate-700 font-medium leading-snug pt-0.5" data-id="element-154">
                {p.text}
              </span>
            </li>)}
        </ul>

        <p className="text-center mt-10 text-lg text-brand-ink font-semibold max-w-md mx-auto leading-snug" data-id="element-155">
          Los chicos aprenden muchísimo con actividades simples, cotidianas y
          bien pensadas.
        </p>
      </div>
    </section>;
}